import * as Yup from "yup";

// フォームの型
export interface FormValues {
  personalInfo: {
    email: string;
  };
}

// バリデーション
export const validationSchema = Yup.object().shape({
  personalInfo: Yup.object().shape({
    email: Yup.string().required("Eメールアドレスを入力してください"),
  }),
});

// 初期値
export const initialValues: FormValues = {
  personalInfo: {
    email: "",
  },
};
